import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const BannerModuleLoadable = loadable(() => import('./BannerModule'), {
  resolveComponent: components => components.BannerModule
});

export const BannerModule = WithLazyHydration(BannerModuleLoadable, {
  name: 'BannerModule'
});
